import { Component } from "@angular/core";

@Component({
  selector: "app-gestao-home",
  templateUrl: "gestao-home.component.html",
  styleUrls: ["gestao-home.component.scss"],
})
export class GestaoHomeComponent {
  constructor() {}
}
